module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_myreal_m2.f3578a16377fbb61df203331ec01d5e1.png";